import { render, staticRenderFns } from "./Skeleton.vue?vue&type=template&id=40f237a5"
import script from "./Skeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./Skeleton.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports